import React from 'react';
import styles from './Team.module.css';

function Team() {
  const teamMembers = [
    {
      name: "Bennett Chen",
      designation: "Co-founder & Managing Director",
      image: "Bennett-Chen.jpg"
    },
    {
      name: "Raymond Ling",
      designation: "Co-founder & Project Delivery Director",
      image: "Raymond.png"
    },
    {
      name: "Andy Bien",
      designation: "Chief Aviation Officer",
      image: "Andy-Bien.jpg"
    },
    {
      name: "Dr. Michael Cheng",
      designation: "Chief Technology & Strategy Officer",
      image: "Michael.jpeg"
    }
  ];

  return (
    <section className={styles.section} id="team">
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>Leadership & Industry Associations</h2>
        
        <div className={styles.teamGrid}>
          {teamMembers.map((member, index) => (
            <div key={index} className={styles.teamMember}>
              <div className={styles.photoContainer}>
                <img 
                  src={`${process.env.PUBLIC_URL}/images/headshots/${member.image}`}
                  alt={member.name}
                  className={styles.photo}
                />
              </div>
              <h3 className={styles.name}>{member.name}</h3>
              <p className={styles.designation}>{member.designation}</p>
            </div>
          ))}
        </div>
        
        <div className={styles.aaisSection}>
          <p className={styles.aaisText}>
            We are proud members of the AAIS community and associate members of{' '}
            <a 
              href="https://aais.org.sg/" 
              target="_blank" 
              rel="noopener noreferrer"
              className={styles.aaisLink}
            >
              <img 
                src={`${process.env.PUBLIC_URL}/images/aais.png`}
                alt="AAIS"
                className={styles.aaisLogo}
              />
            </a>
            {' '}the Association of Aerospace Industries (Singapore).
          </p>
        </div>
      </div>
    </section>
  );
}

export default Team;